import { GoogleReCaptchaConfig } from '@msc-b2c/interfaces/types';
import { getLanguageCode, useScript } from '@msc-b2c/shared-utils';
import { useEffect } from 'react';

interface RecaptchaProps {
  manageTokenRecaptcha: (response: string) => void;
  config: GoogleReCaptchaConfig;
  isDisabled: boolean;
}

export const Recaptcha: React.FC<RecaptchaProps> = ({
  manageTokenRecaptcha,
  config,
  isDisabled = false,
}) => {
  const [isLoaded, hasError] = useScript({
    src: `${config.url}?hl=${getLanguageCode()?.toLocaleLowerCase()}`,
  });

  useEffect(() => {
    window.handleRecaptcha = (response: string) => {
      manageTokenRecaptcha(response);
    };
  }, [manageTokenRecaptcha]);

  return (
    <div
      id="recaptcha"
      className={`g-recaptcha${isDisabled ? ' hide' : ''}`}
      data-sitekey={config.siteKey}
      data-callback="handleRecaptcha"
      data-size="invisible"
    />
  );
};
